export const INVALID_COUPON = "Invalid coupon code!";